import { render, staticRenderFns } from "./camara.vue?vue&type=template&id=79513b22&"
import script from "./camara.vue?vue&type=script&lang=js&"
export * from "./camara.vue?vue&type=script&lang=js&"
import style0 from "./camara.vue?vue&type=style&index=0&id=79513b22&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports